import { useState } from 'react';
import { Eraser } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const ResetStatsButton = ({ onConfirm, disabled }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="interval-reset-stats"
        disabled={disabled}
        onClick={() => setOpen(true)}
        className="h-11 px-4 rounded-full border border-white/15 text-white/60 text-xs uppercase tracking-[0.2em] inline-flex items-center gap-2 hover:bg-white/5 disabled:opacity-40"
      >
        <Eraser className="w-4 h-4" /> Azzera statistiche
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="interval-reset-dialog" className="bg-[#111112] border-white/10 text-white">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-bebas text-3xl tracking-wide">Azzerare le statistiche?</AlertDialogTitle>
            <AlertDialogDescription className="text-white/55">Verranno cancellati i punti deboli e il miglior punteggio. Le impostazioni dell'esercizio restano.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="interval-reset-cancel" className="bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white">Annulla</AlertDialogCancel>
            <AlertDialogAction data-testid="interval-reset-confirm" onClick={onConfirm} className="bg-rose-500 text-white hover:bg-rose-400">Azzera</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
